import {graphql} from 'react-relay'

export const query = graphql`
  query AgentTypeParametersQuery($locator: String!) {
    agentType(agentTypeLocator: $locator) {
      ...AgentTypeParameters_agentType
    }
  }
`
